import { Controller } from 'stimulus';

class Invitation extends Controller {
  copyLink() {
    this.linkTarget.select();
    this.linkTarget.setSelectionRange(0, 99999);

    document.execCommand('copy');
  }
}

Invitation.targets = [
  'link',
  'copy',
];

export default Invitation;
